
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lazada",
      function () {
        return require("private-next-pages/lazada.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lazada"])
      });
    }
  